import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PageHeader from "components/PageLayout";
import SearchPanel from "components/SearchPanel";
import { SearchProvider } from "context/SearchContext";
import { Filter, Plus } from "lucide-react";

// Local config: only used by this page
// const SECTION_ROUTES = [
//   { to: "orders", label: "Orders", key: "orders" },
// ];

export default function RulesPage() {
  const navigate = useNavigate();
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <div>
      {/* Page frame header w/ subnavigation via tabs */}
      <PageHeader
        title="Rule Performance"
        subtitle="Monitor payment routing rule changes at scale."
        actions={
          <>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/rules/create")}
            >
              <Plus className="h-4 w-4" />
              Create Rule
            </button>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/rules/bulk-create")}
            >
              <Plus className="h-4 w-4" />
              Bulk Create Rules
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setFiltersOpen(true)}
            >
              <Filter className="h-4 w-4" />
              Filters
            </button>
          </>
        }
      />

      <div className="container py-6">
        <SearchProvider namespace="rules">
          <Outlet />
          {/* Your right-side sliding panel stays the same */}
          <SearchPanel
            namespace="rules"
            title="Filters Rules"
            isExpanded={filtersOpen}
            onClose={() => setFiltersOpen(false)}
          />
        </SearchProvider>
      </div>
    </div>
  );
}
